<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-small-size-66 md-xsmall-size-100 md-medium-size-40 mx-auto"
          >
            <form @submit.prevent="signIn">
            <login-card header-color="primary">
              <h4 slot="title" class="card-title">Matt + Charlie</h4>
              <p slot="description" class="description">Please enter the username and password found on your invitation</p>
              <md-field class="md-form-group" slot="inputs">
                <md-icon>face</md-icon>
                <label>Username</label>
                <md-input v-model="username" autocapitalize="off" autocomplete="off" spellcheck="false" autocorrect="off"></md-input>
              </md-field>
              <md-field class="md-form-group" slot="inputs">
                <md-icon>lock_outline</md-icon>
                <label>Password</label>
                <md-input type="password" v-model="password"></md-input>
              </md-field>
              <md-button type="submit" slot="footer" class="md-button md-default md-sm">
                Login
              </md-button>
            </login-card>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { LoginCard } from "@/components";

export default {
  components: {
    LoginCard
  },
  bodyClass: "login-page",
  data() {
    return {
      username: null,
      password: null
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/login_background.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    async signIn() {
      const { username, password } = this
      await Auth.signIn(username, password)
      AmplifyEventBus.$emit('authState', 'signedIn')
      // this.$parent.username = username;
      const userDetails = await Auth.currentAuthenticatedUser()
      console.log(userDetails)
      this.$parent.user.username = _.get(userDetails, 'username')
      this.$router.push('/')
    }
  }
};
</script>

<style lang="css"></style>
